interface BadgeProps {
  text: string
  classNames?: string
}

const Badge = ({ text, classNames }: BadgeProps) => {
  return (
    <div
      className={`text-xs whitespace-nowrap text-gray-300 rounded-md px-1 py-[1px] ${classNames}`}
    >
      {text}
    </div>
  )
}

export default Badge
